<app-tracking-screen [tracking]="tracking" [loading]="loading" [notError]="notError" [query]="query"></app-tracking-screen>